import { Checkout } from '@trmediaab/checkout';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import bugsnag from '../utils/bugsnag';
import useResizeObserver from '../utils/useResizeObserver';
import Page from './Page';

function CheckoutContainer({ site }) {
  const {
    query: { sku, campaign, ...props },
  } = useRouter();

  useResizeObserver();

  const onAuthentication = useCallback(user => {
    if (!window.parent) {
      return;
    }

    window.parent.postMessage(
      {
        action: 'authentication',
      },
      window.location.origin,
    );

    if (user != null) {
      bugsnag.setUser(user.id, user.email, user.name);
    }
  }, []);

  if (!sku && !campaign) {
    return null;
  }

  return (
    <Checkout
      sku={sku}
      campaign={campaign}
      containerVariant="wide"
      onAuthentication={onAuthentication}
      site={site}
      {...props}
    />
  );
}

CheckoutContainer.propTypes = {
  site: PropTypes.string,
};

function Embed({ theme, site }) {
  return (
    <Page theme={theme} p="3">
      <CheckoutContainer site={site} />
    </Page>
  );
}

Embed.propTypes = {
  theme: PropTypes.object,
  site: PropTypes.string,
};

export default Embed;
